import state from './state'
import * as getters from './getters'
import mutations from './mutations'

export default {
  state,
  getters,
  mutations
}



//////////////////
// WEBPACK FOOTER
// ../raypro_ui/src/store/modules/website/index.js
// module id = null
// module chunks = 